"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CompactExprRendering = void 0;
const React = require("react");
const certlogic_js_1 = require("certlogic-js");
/**
 * A stateless React component that renders a CertLogic expression in a notation that's more compact than the underlying JSON.
 * The resulting DOM is static, so can be statically rendered.
 */
const CompactExprRendering = ({ expr }) => {
    if (typeof expr === "string") {
        return React.createElement("span", { className: "simple-value" }, expr);
    }
    if ((0, certlogic_js_1.isInt)(expr)) {
        return React.createElement("span", { className: "simple-value" }, expr);
    }
    if (typeof expr === "boolean") {
        return React.createElement("span", { className: "simple-value" }, expr ? "true" : "false");
    }
    if (Array.isArray(expr)) {
        return React.createElement("div", { className: "array" },
            React.createElement("span", { className: "keyword push-right" }, "["),
            expr.map((subExpr, index) => React.createElement("div", { className: "inline", key: index },
                index > 0 && React.createElement("span", { className: "push-right" }, ","),
                React.createElement(exports.CompactExprRendering, { expr: subExpr, key: index }))),
            React.createElement("span", { className: "keyword push-left" }, "]"));
    }
    if (typeof expr === "object") {
        const [operator, values] = Object.entries(expr)[0];
        switch (operator) {
            case "var": {
                return React.createElement("div", { className: "operation" },
                    React.createElement("span", { className: "keyword" }, "/"),
                    React.createElement("span", { className: "path" }, values));
            }
            case "if": {
                const [guard, then, else_] = values;
                return React.createElement("div", { className: "operation" },
                    React.createElement("span", { className: "keyword push-both" }, "if"),
                    React.createElement(exports.CompactExprRendering, { expr: guard }),
                    React.createElement("span", { className: "keyword push-both" }, "then"),
                    React.createElement(exports.CompactExprRendering, { expr: then }),
                    React.createElement("span", { className: "keyword push-both" }, "else"),
                    React.createElement(exports.CompactExprRendering, { expr: else_ }));
            }
            case "and": {
                if (values.length === 2) {
                    return React.createElement("div", { className: "operation" },
                        React.createElement(exports.CompactExprRendering, { expr: values[0] }),
                        React.createElement("span", { className: "keyword push-both" }, "and"),
                        React.createElement(exports.CompactExprRendering, { expr: values[1] }));
                }
                return React.createElement("div", { className: "operation" },
                    React.createElement("span", { className: "variadic-operator" }, "and"),
                    React.createElement("div", { className: "indent" }, values.map((subExpr, index) => React.createElement("div", { key: index },
                        React.createElement(exports.CompactExprRendering, { expr: subExpr })))));
            }
            case "===":
            case ">":
            case "<":
            case ">=":
            case "<=":
            case "after":
            case "before":
            case "not-after":
            case "not-before":
            case "+":
            case "in": {
                return React.createElement("div", { className: "operation" }, values.map((operand, index) => React.createElement("div", { className: "inline", key: index },
                    index > 0 &&
                        React.createElement("span", { className: "keyword push-both" }, operator),
                    React.createElement(exports.CompactExprRendering, { expr: operand }))));
            }
            case "!": {
                return React.createElement("div", { className: "operation" },
                    React.createElement("span", { className: "keyword push-right" }, "!"),
                    React.createElement(exports.CompactExprRendering, { expr: values[0] }));
            }
            case "plusTime": {
                const [operand, amount, unit] = values;
                return React.createElement("div", { className: "operation" },
                    React.createElement(exports.CompactExprRendering, { expr: operand }),
                    amount >= 0 && React.createElement("span", { className: "keyword push-both" }, "+"),
                    React.createElement("span", { className: "simple-value" }, amount),
                    React.createElement("span", { className: "push-left keyword" }, unit + (amount === 1 ? "" : "s")));
            }
            case "reduce": {
                return React.createElement("div", { className: "operation" },
                    React.createElement(exports.CompactExprRendering, { expr: values[0] }),
                    React.createElement("span", { className: "keyword" }, ".reduce("),
                    React.createElement("span", { className: "signature push-right" }, "(accumulator, current) \u2192"),
                    React.createElement(exports.CompactExprRendering, { expr: values[1] }),
                    React.createElement("span", { className: "keyword push-right" }, ","),
                    React.createElement("span", { className: "signature push-right" }, "initial:"),
                    React.createElement(exports.CompactExprRendering, { expr: values[2] }),
                    React.createElement("span", { className: "keyword" }, ")"));
            }
            case "extractFromUVCI": {
                return React.createElement("div", { className: "operation" },
                    React.createElement(exports.CompactExprRendering, { expr: values[0] }),
                    React.createElement("span", { className: "keyword" }, ".extractFromUVCI(#"),
                    React.createElement("span", { className: "simple-value" }, values[1]),
                    React.createElement("span", { className: "keyword" }, ")"));
            }
            case "dccDateOfBirth": {
                return React.createElement("div", { className: "operation" },
                    React.createElement("span", { className: "keyword" }, "DCC-DOB("),
                    React.createElement(exports.CompactExprRendering, { expr: values[0] }),
                    React.createElement("span", { className: "keyword" }, ")"));
            }
        }
    }
    return React.createElement("span", { className: "error" },
        "no rendering defined (yet) for: ",
        JSON.stringify(expr));
};
exports.CompactExprRendering = CompactExprRendering;
